export const ExhibitorCategories = `
  fragment ExhibitorCategories on ExhibitorCategoryDetail {
    title
  }
`
export const Categories = `
  fragment Categories on ExhibitorCategoryDataReference {
    value
    label
  }
`
